import { MERGE_CHANGE_KINDS } from "../types/titleMerge";
var TABLE_ORDER = [
    "deposit_records",
    "periodical_libraries",
    "periodical_issues",
    "periodical_check_tasks",
    "titles",
    "title_names",
    "product_numbers",
    "products",
    "product_prices",
    "products_relations",
    "title_skc_records",
    "skc_owner_keys",
    "investigation_notes",
    "title_library_notes",
    "agency_notifications",
];
export var MERGE_IMPACT_TABLE_LABEL_IDS = {
    deposit_records: "ui-br-legaldeposits.titleMerge.impact.table.depositRecords",
    periodical_libraries: "ui-br-legaldeposits.titleMerge.impact.table.periodicalLibraries",
    periodical_issues: "ui-br-legaldeposits.titleMerge.impact.table.periodicalIssues",
    periodical_check_tasks: "ui-br-legaldeposits.titleMerge.impact.table.periodicalCheckTasks",
    titles: "ui-br-legaldeposits.titleMerge.impact.table.titles",
    title_names: "ui-br-legaldeposits.titleMerge.impact.table.titleNames",
    product_numbers: "ui-br-legaldeposits.titleMerge.impact.table.productNumbers",
    products: "ui-br-legaldeposits.titleMerge.impact.table.products",
    product_prices: "ui-br-legaldeposits.titleMerge.impact.table.productPrices",
    products_relations: "ui-br-legaldeposits.titleMerge.impact.table.productsRelations",
    title_skc_records: "ui-br-legaldeposits.titleMerge.impact.table.titleSkcRecords",
    skc_owner_keys: "ui-br-legaldeposits.titleMerge.impact.table.skcOwnerKeys",
    investigation_notes: "ui-br-legaldeposits.titleMerge.impact.table.investigationNotes",
    title_library_notes: "ui-br-legaldeposits.titleMerge.impact.table.titleLibraryNotes",
    agency_notifications: "ui-br-legaldeposits.titleMerge.impact.table.agencyNotifications",
};
export var MERGE_IMPACT_KIND_LABEL_IDS = {
    MOVE: "ui-br-legaldeposits.titleMerge.impact.kind.MOVE",
    FOLD: "ui-br-legaldeposits.titleMerge.impact.kind.FOLD",
    DELETE: "ui-br-legaldeposits.titleMerge.impact.kind.DELETE",
    UPDATE: "ui-br-legaldeposits.titleMerge.impact.kind.UPDATE",
    CREATE: "ui-br-legaldeposits.titleMerge.impact.kind.CREATE",
};
var tableRank = function (table) {
    var index = TABLE_ORDER.indexOf(table);
    return index === -1 ? TABLE_ORDER.length : index;
};
export var summarizeMergeImpact = function (plan) {
    if (!plan)
        return [];
    return Object.entries(plan.counts)
        .map(function (_a) {
        var table = _a[0], byKind = _a[1];
        return ({
            table: table,
            known: MERGE_IMPACT_TABLE_LABEL_IDS[table] != null,
            entries: MERGE_CHANGE_KINDS.filter(function (kind) { var _a; return ((_a = byKind[kind]) !== null && _a !== void 0 ? _a : 0) > 0; }).map(function (kind) { return ({ kind: kind, count: byKind[kind] }); }),
        });
    })
        .filter(function (row) { return row.entries.length > 0; })
        .sort(function (a, b) {
        return tableRank(a.table) - tableRank(b.table) ||
            a.table.localeCompare(b.table);
    });
};
export var countMergeChanges = function (plan, table, kind) { var _a, _b, _c; return (_c = (_b = (_a = plan === null || plan === void 0 ? void 0 : plan.counts) === null || _a === void 0 ? void 0 : _a[table]) === null || _b === void 0 ? void 0 : _b[kind]) !== null && _c !== void 0 ? _c : 0; };
